<!-- @format -->

<ng-container *transloco="let t">
  @if (stateObject?.isAttainmentAboutToExpire) {
    <sis-tiny-badge [variant]="'accent'">
      {{ t("PLAN.MODULE.EXPIRATION_IMMINENT") }}
      {{ stateObject.attainmentExpiryDate | localDateFormat }}
    </sis-tiny-badge>
  }
  @if (stateObject?.invalidSelectionWithoutApproval) {
    <sis-tiny-badge [variant]="'danger'">
      {{ t("PLAN.INVALID_SELECTIONS.NOTIFICATION") }}
    </sis-tiny-badge>
  }
  @if (breaksModuleContentApproval(stateObject)) {
    <sis-tiny-badge [variant]="'danger'">
      {{ t("PLAN.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL.NOTIFICATION") }}
    </sis-tiny-badge>
  }
  @if (documentState === "DRAFT") {
    <sis-tiny-badge [variant]="'accent'">
      {{ t("VISIBLE_DOCUMENT_STATE.DRAFT") }}
    </sis-tiny-badge>
  }
  @if (documentState === "DELETED") {
    <sis-tiny-badge [variant]="'danger'">
      {{ t("VISIBLE_DOCUMENT_STATE.DELETED") }}
    </sis-tiny-badge>
  }
</ng-container>
